import { QueueTypeS } from "@ugg/shared/utils/queue-type-helpers";

type TierListSettings = {
  [key in QueueTypeS]?: {
    showAgainst?: boolean;
    showBan?: boolean;
    showPick?: boolean;
    showRole?: boolean;
    showTier?: boolean;
  };
};

export const tierListSettings: TierListSettings = {
  [QueueTypeS.RANKED_SOLO]: {
    showAgainst: true,
    showBan: true,
    showPick: true,
    showRole: true,
    showTier: true,
  },
  [QueueTypeS.RANKED_FLEX]: {
    showAgainst: true,
    showBan: true,
    showPick: true,
    showRole: true,
    showTier: true,
  },
  [QueueTypeS.NORMAL_BLIND]: {
    showAgainst: false,
    showBan: false,
    showPick: false,
    showRole: true,
    showTier: true,
  },
  [QueueTypeS.QUICKPLAY]: {
    showAgainst: false,
    showBan: false,
    showPick: true,
    showRole: true,
    showTier: true,
  },
  [QueueTypeS.SWIFTPLAY]: {
    showAgainst: false,
    showBan: false,
    showPick: true,
    showRole: true,
    showTier: true,
  },
  [QueueTypeS.NORMAL_DRAFT]: {
    showAgainst: false,
    showBan: true,
    showPick: true,
    showRole: true,
    showTier: true,
  },
  [QueueTypeS.ARAM]: {
    showAgainst: false,
    showBan: false,
    showPick: true,
    showRole: false,
    showTier: true,
  },
  [QueueTypeS.NEXUS_BLITZ]: {
    showAgainst: false,
    showBan: true,
    showPick: true,
    showRole: true,
    showTier: true,
  },
  [QueueTypeS.URF]: {
    showAgainst: false,
    showBan: false,
    showPick: true,
    showRole: false,
    showTier: true,
  },
  [QueueTypeS.ARURF]: {
    showAgainst: false,
    showBan: false,
    showPick: true,
    showRole: false,
    showTier: true,
  },
  [QueueTypeS.ONE_FOR_ALL]: {
    showAgainst: false,
    showBan: true,
    showPick: true,
    showRole: false,
    showTier: true,
  },
};
